import React, { Component } from "react";
import Table from "../common/Table";
import Pagination from "react-js-pagination";
import Row from "../common/Row";
import MyPagination from "../common/Pagination";

export default class TableTransfer extends Table {
  constructor(props) {
    super(props);
    this.handleDownloadCsv = this.handleDownloadCsv.bind(this);
  }

  handleDownloadCsv() {
    let searchConditions = this.props.searchConditions;
    let myURL = "/transfers/download?"+ $.param(searchConditions);
    location.href = myURL;
  }

  render() {
    let pageShow = [],
      hasBtnSearch;
    if (!this.props.onSearch) {
      this.state.dataShow = this.props.data.filter(this.searchColumn);
      hasBtnSearch = false;
    } else {
      this.state.dataShow = this.props.data;
      hasBtnSearch = true;
    }

    for (
      let i = (this.state.activePage - 1) * this.state.itemsCountPerPage;
      i < this.state.dataShow.length &&
      i < this.state.activePage * this.state.itemsCountPerPage;
      i++
    ) {
      pageShow.push(this.state.dataShow[i]);
    }
    return (
      <React.Fragment>
        <table className="table table-stripped table-hover mb-0">
          <thead className="thead-light">
            <tr>
              {this.props.header.map((item, i) => (
                <th
                  onClick={item.isSort ? this.handleSortAllData : () => {}}
                  className={
                    item.isSort
                      ? this.state.columnSort == item.name
                        ? "isSort sorting"
                        : "isSort"
                      : ""
                  }
                  data-sorttype={this.state.typeSort}
                  column={item.name}
                  key={i}
                >
                  {item.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageShow.map((dataRow, i) => {
              if (this.props.hasOwnProperty("optionTR")) {
                return (
                  <Row
                    color={
                      this.props.optionTR.colors[
                        dataRow[this.props.optionTR.conditionColumn]
                      ]
                    }
                    onEdit={this.handleEdit}
                    onDelete={this.handleDelete}
                    key={i}
                    data={dataRow}
                    header={this.props.header}
                  />
                );
              } else {
                return (
                  <Row
                    color=""
                    removeClick={this.props.removeClick}
                    onEdit={this.handleEdit}
                    onDelete={this.handleDelete}
                    key={i}
                    data={dataRow}
                    header={this.props.header}
                  />
                );
              }
            })}
          </tbody>
        </table>
        <div className="card-footer">
          {this.props.hasOwnProperty("myPagination") &&
          this.props.hasOwnProperty("searchConditions") &&
          this.props.myPagination == 1 ? (
            <div className="row">
              <div className="col-sm-2">
                  <div className="input-group-prepend">
                      <button onClick={this.handleDownloadCsv} className="btn bg-purple text-white">CSVダウンロード</button>
                  </div>
              </div>
              <div className="col-sm-8">
                <nav>
                  <MyPagination
                    onSearch={this.handleSearchByPage}
                    searchConditions={this.props.searchConditions}
                    lastPage={this.props.lastPage}
                    currentPage={this.props.currentPage}
                  />
                </nav>
              </div>
              <div className="col-sm-2 text-right">
                <strong>
                  {this.props.total}件中{this.props.from}から{this.props.to}
                  まで表示
                </strong>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-2">
                <button type="button" className="btn bg-purple text-white">
                  振込済にする
                </button>
                <button
                  type="button"
                  className="btn bg-light cash-btn-retransfer"
                >
                  再振込する
                </button>
              </div>
              <div className="col-sm-8">
                <nav>
                  <Pagination
                    innerClass="pagination justify-content-center mb-0"
                    activePage={this.state.activePage}
                    itemClass="page-item"
                    activeClass="active"
                    activeLinkClass="page-link"
                    linkClass="page-link"
                    itemsCountPerPage={this.state.itemsCountPerPage}
                    totalItemsCount={this.state.dataShow.length}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              </div>
              <div className="col-sm-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-white">表示</span>
                  </div>
                  <select
                    className="form-control"
                    onChange={this.handleCountPerPageChange}
                    value={this.state.itemsCountPerPage}
                  >
                    <option>10</option>
                    <option>20</option>
                    <option>30</option>
                    <option>50</option>
                    <option>100</option>
                  </select>
                  <div className="input-group-append">
                    <span className="input-group-text">件</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
